import React from 'react';
import { Icon, Tooltip, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { SettingsHeading } from '../../../SidebarMenu/styles';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';
import { useCloneableSettings } from '../hooks/useCloneableSettings';
import { ENTERPRISE_ENV } from '../../../../utils/helper';
import { useArtboardContext, CONTEXT_KEYS } from '../../../../context/complexArtboardContext';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

export const CloneableSection = ({ CurrentDesign, isInteractiveDesign, readOnly, showTooltip = true, customStyles }) => {
  const { t } = useTranslation(NAMESPACES);
  const { isCloneable, onCloneableChange } = useCloneableSettings();

  const interactiveDesignSelector = React.useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesignFromContext] = useArtboardContext(interactiveDesignSelector, 'CloneableSection');
  const effectiveIsInteractiveDesign = isInteractiveDesign !== undefined ? isInteractiveDesign : isInteractiveDesignFromContext;

  if (!ENTERPRISE_ENV || CurrentDesign !== "document" || effectiveIsInteractiveDesign) {
    return null;
  }

  return (
    <SettingsHeading complexDesign cloneable style={customStyles}>
      {t(
        DESIGN_AREA_SETTINGS_TAB.CLONEABLE_LABEL.key,
        DESIGN_AREA_SETTINGS_TAB.CLONEABLE_LABEL.value,
      )}{' '}
      {showTooltip && (
        <Tooltip
          placement="topLeft"
          title={t(
            DESIGN_AREA_SETTINGS_TAB.CLONEABLE_TOOLTIP.key,
            DESIGN_AREA_SETTINGS_TAB.CLONEABLE_TOOLTIP.value,
          )}
        >
          <Icon type="question-circle" />
        </Tooltip>
      )}
      <Switch checked={isCloneable} onChange={onCloneableChange} />
    </SettingsHeading>
  );
};


